"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDJSONParser = void 0;
var TDNode_1 = require("../TDNode");
var TDJSONParserOption_1 = require("./TDJSONParserOption");
var StringCharSource_1 = require("../core/StringCharSource");
var StringBuilder_1 = require("../core/StringBuilder");
var TreeDoc_1 = require("../TreeDoc");
var ClassUtil_1 = require("../core/ClassUtil");
var __1 = require("..");
var EOF = '\uFFFF';
var TDJSONParser = /** @class */ (function () {
    function TDJSONParser() {
    }
    TDJSONParser.get = function () {
        return TDJSONParser.instance;
    };
    /** Parse all the JSON objects in the input stream until EOF and store them inside an root node with array type */
    TDJSONParser.prototype.parseAll = function (src, option, node, isRoot) {
        if (option === void 0) { option = new TDJSONParserOption_1.TDJSONParserOption(); }
        if (node === void 0) { node = new TreeDoc_1.TreeDoc('root', option.uri).root; }
        if (isRoot === void 0) { isRoot = true; }
        var opt = option instanceof TDJSONParserOption_1.TDJSONParserOption ? option : __1.LangUtil.mergeDeep(new TDJSONParserOption_1.TDJSONParserOption(), option);
        opt.setDefaultRootType(TDNode_1.TDNodeType.MAP);
        if (typeof src === 'string')
            src = new StringCharSource_1.StringCharSource(src);
        var doc = TreeDoc_1.TreeDoc.ofArray();
        var docId = 0;
        while (src.skipSpacesAndReturnsAndCommas())
            TDJSONParser.get().parse(src, opt.setDocId(docId++), doc.root.createChild());
        return doc.root;
    };
    TDJSONParser.prototype.contains = function (str, c) {
        return str.indexOf(c) >= 0;
    };
    TDJSONParser.prototype.parse = function (src, option, node, isRoot) {
        if (option === void 0) { option = new TDJSONParserOption_1.TDJSONParserOption(); }
        if (node === void 0) { node = new TreeDoc_1.TreeDoc('root', option.uri).root; }
        if (isRoot === void 0) { isRoot = true; }
        var opt = option instanceof TDJSONParserOption_1.TDJSONParserOption ? option : __1.LangUtil.mergeDeep(new TDJSONParserOption_1.TDJSONParserOption(), option);
        opt.buildTerms();
        if (typeof src === 'string')
            src = new StringCharSource_1.StringCharSource(src);
        var c = TDJSONParser.skipSpaceAndComments(src);
        if (c === EOF)
            return node;
        try {
            node.start = src.getBookmark();
            if (this.contains(opt.deliminatorObjectStart, c))
                return this.parseMap(src, opt, node, true);
            if (this.contains(opt.deliminatorArrayStart, c))
                return this.parseArray(src, opt, node, true);
            if (node.isRoot() && opt.defaultRootType !== undefined) {
                switch (opt.defaultRootType) {
                    case TDNode_1.TDNodeType.MAP:
                        return this.parseMap(src, opt, node, false);
                    case TDNode_1.TDNodeType.ARRAY:
                        return this.parseArray(src, opt, node, false);
                }
            }
            if (c === '"' || c === "'" || c === '`') {
                src.read();
                var sb = new StringBuilder_1.StringBuilder();
                src.readQuotedToString(sb, c);
                this.readContinuousString(src, sb);
                return node.setValue(sb.toString());
            }
            if (isRoot && opt.defaultRootType === TDNode_1.TDNodeType.SIMPLE) {
                return node.setValue(ClassUtil_1.ClassUtil.toSimpleObject(src.readUntilTerminator("\r\n")));
            }
            var term = opt._termValue;
            if (node.parent != null)
                // parent.type can either be ARRAY or MAP.
                term = node.parent.type === TDNode_1.TDNodeType.ARRAY ? opt._termValueInArray : opt._termValueInMap;
            var str = src.readUntilTerminator(term, opt._termValueStrs).trim();
            if (!src.isEof() && this.contains(opt.deliminatorKey, src.peek())) { // it's a path compression such as: a:b:c,d:e -> {a: {b: c}}
                src.skip();
                node.setType(TDNode_1.TDNodeType.MAP);
                this.parse(src, opt, node.createChild(str), false);
                return node;
            }
            if (!src.isEof() && this.contains(opt.deliminatorObjectStart, src.peek())) {
                // Type wrapper: A value with type in the form of `type{attr1:val1:attr2:val2}
                node.createChild(opt.KEY_TYPE).setValue(str);
                return this.parseMap(src, opt, node, true);
            }
            // A simple value
            node.setValue(ClassUtil_1.ClassUtil.toSimpleObject(str));
            return node;
        }
        finally {
            node.end = src.getBookmark();
        }
    };
    TDJSONParser.prototype.readContinuousString = function (src, sb) {
        var c;
        while ((c = TDJSONParser.skipSpaceAndComments(src)) !== EOF) {
            if ('"`\''.indexOf(c) < 0)
                break;
            src.read();
            src.readQuotedToString(sb, c);
        }
    };
    /**
     * @return char next char to read (peeked), if '\uFFFF' indicate it's EOF
     */
    TDJSONParser.skipSpaceAndComments = function (src) {
        while (src.skipSpacesAndReturns()) {
            var c = src.peek();
            if (c === '#') {
                if (src.skipUntilTerminator('\n'))
                    src.skip(1);
                continue;
            }
            if (c !== '/' || src.isEof(1))
                return c;
            var c1 = src.peek(1);
            switch (c1) {
                case '/': // line comments
                    if (src.skipUntilTerminator('\n'))
                        src.skip(1);
                    break;
                case '*': // block comments
                    src.skip(2);
                    src.skipUntilMatch('*/', true);
                    break;
                default:
                    return c1;
            }
        }
        return EOF;
    };
    TDJSONParser.prototype.parseMap = function (src, opt, node, withStartBracket) {
        node.type = TDNode_1.TDNodeType.MAP;
        if (withStartBracket)
            src.skip();
        for (var i = 0;;) {
            var c = TDJSONParser.skipSpaceAndComments(src);
            if (c === EOF) {
                if (withStartBracket)
                    throw src.createParseRuntimeException("EOF while expecting matching '}' with '{' at " + node.start);
                break;
            }
            if (this.contains(opt.deliminatorObjectEnd, c)) {
                src.skip();
                break;
            }
            if (src.startsWith(opt.deliminatorValue)) { // Skip ,
                src.skip(opt.deliminatorValue.length);
                continue;
            }
            var key = void 0;
            if (c === '"' || c === "'" || c === '`') {
                src.skip();
                key = src.readQuotedString(c);
                c = TDJSONParser.skipSpaceAndComments(src);
                // if (c === EOF)
                //   break;
                //        if (c == EOF)
                //          break;
                if (!src.startsWith(opt.deliminatorKey)
                    && !this.contains(opt.deliminatorObjectStart, c)
                    && !this.contains(opt.deliminatorArrayStart, c)
                    && !this.contains(opt.deliminatorValue, c)
                    && !this.contains(opt.deliminatorObjectEnd, c))
                    throw src.createParseRuntimeException("No '" + opt.deliminatorKey + "' after key:" + key);
            }
            else {
                key = src.readUntilTerminator(opt._termKey, opt._termKeyStrs, 1, Number.MAX_VALUE).trim();
                if (src.isEof())
                    throw src.createParseRuntimeException("No '" + opt.deliminatorKey + "' after key:" + key);
                c = src.peek();
            }
            if (src.startsWith(opt.deliminatorKey))
                src.skip(opt.deliminatorKey.length);
            if (src.startsWith(opt.deliminatorValue) || this.contains(opt.deliminatorObjectEnd, c)) // If there's no ':', we consider it as indexed value (array)
                node.createChild(i + '').setValue(key);
            else {
                var childNode = this.parse(src, opt, node.createChild(key), false);
                if (opt.KEY_ID === key && childNode.type === TDNode_1.TDNodeType.SIMPLE) {
                    var id = childNode.value + '';
                    if (opt.docId !== undefined) {
                        id += "_" + opt.docId;
                        childNode.value = id;
                    }
                    node.doc.idMap[id] = node;
                }
                else if (TDNode_1.TDNode.REF_KEY === key && childNode.type === TDNode_1.TDNodeType.SIMPLE) {
                    if (opt.docId !== undefined)
                        childNode.value += "_" + opt.docId;
                }
            }
            i++;
        }
        return node;
    };
    TDJSONParser.prototype.parseArray = function (src, opt, node, withStartBracket) {
        node.type = TDNode_1.TDNodeType.ARRAY;
        if (withStartBracket)
            src.skip();
        while (true) {
            var c = TDJSONParser.skipSpaceAndComments(src);
            if (c === EOF) {
                if (withStartBracket)
                    throw src.createParseRuntimeException("EOF while expecting matching ']' with '[' at " + node.start);
                break;
            }
            if (this.contains(opt.deliminatorArrayEnd, c)) {
                src.skip();
                break;
            }
            this.parse(src, opt, node.createChild(), false);
            c = TDJSONParser.skipSpaceAndComments(src);
            if (src.startsWith(opt.deliminatorValue)) {
                src.skip(opt.deliminatorValue.length);
            }
        }
        return node;
    };
    TDJSONParser.instance = new TDJSONParser();
    return TDJSONParser;
}());
exports.TDJSONParser = TDJSONParser;
//# sourceMappingURL=TDJSONParser.js.map